import $ from "jquery";
$(document).ready(function () {
    $("body").on("click", ".pointer.input", function (e) {
        var $this = $(e.currentTarget);
        var $list = $this.children("ul");
        if ($this.data("height") === void 0) {
            $this.data("height", $this.outerHeight() + "!important");
        }
        var height = parseInt($this.data("height"));
        $this.toggleClass('input-active');
        $this.css({ height: $this.hasClass("input-active") ? height + $list.outerHeight() : height });
        $this.find(".border").toggleClass('input-active');
        $list.toggleClass('ul-active');
        $this.find(".input-arrow").toggleClass('input-arrow-active');
        $this.find(".input-arrow_left").toggleClass('input-arrow_left-active');
        $this.find(".input-arrow_right").toggleClass('input-arrow_right-active');
        $this.find(".input-rounded").toggleClass('input-rounded-active');
    });
    $('.caldera_forms_form .first_row').on("change blur", "input", function (e) {
        $(e.currentTarget).parents(".caldera_forms_form").find(".row").fadeIn(400);
        $(e.currentTarget).parents(".pointer.input").children("p").html($(e.currentTarget).val() + ' <span aria-hidden="true" role="presentation" class="field_required" style="color:#ee0000;">*</span>');
        $(".pointer.input-active").trigger("click");
    });
});
